import SickPeriod from './SickPeriod';

export default SickPeriod;
